const Notification = {
    Unseen: 1,
    Seen: 2,
    Read: 3
}
export default Notification


